import { ElementRef, EventEmitter } from "@angular/core";
import { AccountService } from '../../../core/auth/account.service';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { SessionService } from '../../session/session.service';
import { SessionControlComponent } from '../../session/session-chat-coach/session-control.component/session-control.component';
import { MessageService } from '../../message/message.service';
import { JhiAlertService, JhiEventManager } from '../../../ng-jhipster/service';
import { SessionStorageService } from "ngx-webstorage";
import { TranslateService } from "@ngx-translate/core";
import { CoachDetailsService } from '../../slot/coach-details.service';
import { Session } from '../../../shared/model/session.model';
import { UserOrganizationCodeService } from '../../user-organization-code/user-organization-code.service';
import { DataSharingConsentService } from '../../data-sharing-consent/data-sharing-consent.service';
import { ZoomService } from '../zoom.service';
import { UserInteractionService } from '../../user-interaction/user-interaction.service';
import { UserService } from '../../../core/user/user.service';
import moment from "moment";
import { TrackerService } from '../../../core/tracker/tracker.service';
import * as i0 from "@angular/core";
import * as i1 from "../../message/message.service";
import * as i2 from "../../../ng-jhipster/service";
import * as i3 from "ngx-webstorage";
import * as i4 from "../../session/session.service";
import * as i5 from "@ng-bootstrap/ng-bootstrap";
import * as i6 from "@ngx-translate/core";
import * as i7 from "../../../core/auth/account.service";
import * as i8 from "../../slot/coach-details.service";
import * as i9 from "../../user-organization-code/user-organization-code.service";
import * as i10 from "../../data-sharing-consent/data-sharing-consent.service";
import * as i11 from "../zoom.service";
import * as i12 from "../../user-interaction/user-interaction.service";
import * as i13 from "../../../core/user/user.service";
import * as i14 from "../../../core/tracker/tracker.service";
import * as i15 from "../../../ng-jhipster/language/jhi-translate.directive";
import * as i16 from "@angular/common";
import * as i17 from "@angular/material/tooltip";
import * as i18 from "@fortawesome/angular-fontawesome";
import * as i19 from "@angular/router";
import * as i20 from "../audio-toggler/audio-toggler.component";
import * as i21 from "../video-toggler/video-toggler.component";
import * as i22 from "../virtual-background-selector/virtual-background-selector.component";
import * as i23 from "@angular/forms";
import * as i24 from "../../../shared/auto-direction-switch/input-auto-direction-switch.directive";
import * as i25 from "../../../shared/modal-success/modal-success.component";
const _c0 = ["reportClientModal"];
function UserSessionControlComponent_li_17_li_15_Template(rf, ctx) { if (rf & 1) {
    const _r17 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 48);
    i0.ɵɵlistener("click", function UserSessionControlComponent_li_17_li_15_Template_li_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r17); const speaker_r15 = restoredCtx.$implicit; i0.ɵɵnextContext(); const _r13 = i0.ɵɵreference(3); const ctx_r16 = i0.ɵɵnextContext(); ctx_r16.selectSpeaker(speaker_r15); return _r13.close(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const speaker_r15 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", speaker_r15.label, " ");
} }
function UserSessionControlComponent_li_17_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "span", 15, 45);
    i0.ɵɵelementStart(4, "a", 6);
    i0.ɵɵelementStart(5, "div", 17);
    i0.ɵɵelement(6, "span", 46);
    i0.ɵɵelementStart(7, "div", 14);
    i0.ɵɵelementStart(8, "div", 19);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(9, "svg", 20);
    i0.ɵɵelement(10, "use", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(11, "span", 22);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelement(13, "fa-icon", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "ul", 47);
    i0.ɵɵtemplate(15, UserSessionControlComponent_li_17_li_15_Template, 2, 1, "li", 25);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const _r0 = i0.ɵɵreference(16);
    i0.ɵɵadvance(12);
    i0.ɵɵtextInterpolate(ctx_r1.selectedSpeaker == null ? null : ctx_r1.selectedSpeaker.label);
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("left", _r0.offsetWidth - 20 + "px");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngForOf", ctx_r1.speakerList);
} }
function UserSessionControlComponent_li_33_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 48);
    i0.ɵɵlistener("click", function UserSessionControlComponent_li_33_Template_li_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r20); const camera_r18 = restoredCtx.$implicit; const ctx_r19 = i0.ɵɵnextContext(); const _r2 = i0.ɵɵreference(21); ctx_r19.selectCamera(camera_r18); return _r2.close(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const camera_r18 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", camera_r18.label, " ");
} }
function UserSessionControlComponent_li_49_Template(rf, ctx) { if (rf & 1) {
    const _r23 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 48);
    i0.ɵɵlistener("click", function UserSessionControlComponent_li_49_Template_li_click_0_listener() { const restoredCtx = i0.ɵɵrestoreView(_r23); const microphone_r21 = restoredCtx.$implicit; const ctx_r22 = i0.ɵɵnextContext(); const _r4 = i0.ɵɵreference(37); ctx_r22.selectMicrophone(microphone_r21); return _r4.close(); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const microphone_r21 = ctx.$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵtextInterpolate1(" ", microphone_r21.label, " ");
} }
function UserSessionControlComponent_li_50_Template(rf, ctx) { if (rf & 1) {
    const _r26 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li");
    i0.ɵɵelementStart(1, "div");
    i0.ɵɵelementStart(2, "span", 15, 49);
    i0.ɵɵelementStart(4, "a", 6);
    i0.ɵɵelementStart(5, "div", 17);
    i0.ɵɵelement(6, "span", 50);
    i0.ɵɵelementStart(7, "div", 14);
    i0.ɵɵelementStart(8, "div", 19);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(9, "svg", 20);
    i0.ɵɵelement(10, "use", 21);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(11, "span", 51);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(12, "fa-icon", 23);
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "ul", 24);
    i0.ɵɵelementStart(14, "div");
    i0.ɵɵelementStart(15, "virtual-background-selector", 52);
    i0.ɵɵlistener("virtualBackgroundSelected", function UserSessionControlComponent_li_50_Template_virtual_background_selector_virtualBackgroundSelected_15_listener($event) { i0.ɵɵrestoreView(_r26); const _r24 = i0.ɵɵreference(3); const ctx_r25 = i0.ɵɵnextContext(); ctx_r25.selectVirtualBackground($event); return _r24.close(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = i0.ɵɵnextContext();
    const _r0 = i0.ɵɵreference(16);
    i0.ɵɵadvance(11);
    i0.ɵɵpropertyInterpolate1("jhiTranslate", "sessionChat.label.virtualBackgrounds.", ctx_r6.selectedVirtualBackground, "");
    i0.ɵɵadvance(2);
    i0.ɵɵstyleProp("left", _r0.offsetWidth - 20 + "px");
} }
function UserSessionControlComponent__svg_use_55_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 53);
} }
function UserSessionControlComponent__svg_use_56_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(0, "use", 54);
} }
function UserSessionControlComponent_div_57_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelement(0, "div", 55);
} }
function UserSessionControlComponent_li_66_Template(rf, ctx) { if (rf & 1) {
    const _r28 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 56);
    i0.ɵɵlistener("click", function UserSessionControlComponent_li_66_Template_li_click_0_listener() { i0.ɵɵrestoreView(_r28); const ctx_r27 = i0.ɵɵnextContext(); return ctx_r27.openReportCoachModal(); });
    i0.ɵɵelement(1, "span", 57);
    i0.ɵɵelementEnd();
} }
function UserSessionControlComponent_ng_template_75_div_0_small_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "small", 67);
} }
function UserSessionControlComponent_ng_template_75_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r34 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 60);
    i0.ɵɵelementStart(1, "div", 61);
    i0.ɵɵelement(2, "h3", 62);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div");
    i0.ɵɵelement(4, "br");
    i0.ɵɵelementStart(5, "textarea", 63);
    i0.ɵɵlistener("ngModelChange", function UserSessionControlComponent_ng_template_75_div_0_Template_textarea_ngModelChange_5_listener($event) { i0.ɵɵrestoreView(_r34); const ctx_r33 = i0.ɵɵnextContext(2); return ctx_r33.reasonOfFlagging = $event; });
    i0.ɵɵpipe(6, "translate");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(7, UserSessionControlComponent_ng_template_75_div_0_small_7_Template, 1, 0, "small", 64);
    i0.ɵɵelement(8, "br");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "div", 65);
    i0.ɵɵelementStart(10, "button", 66);
    i0.ɵɵlistener("click", function UserSessionControlComponent_ng_template_75_div_0_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r34); const ctx_r35 = i0.ɵɵnextContext(2); return ctx_r35.reportClient(); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r30 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(5);
    i0.ɵɵpropertyInterpolate("placeholder", i0.ɵɵpipeBind1(6, 3, "sessionChat.placeholder.enter"));
    i0.ɵɵproperty("ngModel", ctx_r30.reasonOfFlagging);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r30.showReasonOfFlaggingRequired);
} }
function UserSessionControlComponent_ng_template_75_modal_success_1_Template(rf, ctx) { if (rf & 1) {
    const _r37 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "modal-success", 68);
    i0.ɵɵlistener("dismissed", function UserSessionControlComponent_ng_template_75_modal_success_1_Template_modal_success_dismissed_0_listener($event) { i0.ɵɵrestoreView(_r37); const ctx_r36 = i0.ɵɵnextContext(2); return ctx_r36.onDismiss($event); });
    i0.ɵɵpipe(1, "translate");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r31 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("titleText", "sessionChat.title.done")("message", i0.ɵɵpipeBind1(1, 2, ctx_r31.reportSuccessMessage));
} }
function UserSessionControlComponent_ng_template_75_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, UserSessionControlComponent_ng_template_75_div_0_Template, 11, 5, "div", 58);
    i0.ɵɵtemplate(1, UserSessionControlComponent_ng_template_75_modal_success_1_Template, 2, 4, "modal-success", 59);
} if (rf & 2) {
    const ctx_r12 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r12.flagged);
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", ctx_r12.flagged);
} }
const _c1 = function (a0, a1) { return { duration: a0, time: a1 }; };
const _c2 = function () { return { "color": "#44A38B" }; };
const _c3 = function () { return { "color": "#E1E1E1" }; };
export class UserSessionControlComponent extends SessionControlComponent {
    constructor(messageService, alertService, sessionStorage, sessionService, modalService, translate, accountService, coachDetailsService, userOrganizationCodeService, dataSharingConsentService, eventManager, zoomService, userInteractionService, ngbModal, userService, trackerService) {
        super(messageService, alertService, sessionStorage, sessionService, modalService, translate, accountService, coachDetailsService, trackerService);
        this.messageService = messageService;
        this.alertService = alertService;
        this.sessionStorage = sessionStorage;
        this.sessionService = sessionService;
        this.modalService = modalService;
        this.translate = translate;
        this.accountService = accountService;
        this.coachDetailsService = coachDetailsService;
        this.userOrganizationCodeService = userOrganizationCodeService;
        this.dataSharingConsentService = dataSharingConsentService;
        this.eventManager = eventManager;
        this.zoomService = zoomService;
        this.userInteractionService = userInteractionService;
        this.ngbModal = ngbModal;
        this.userService = userService;
        this.trackerService = trackerService;
        this.onAudioStatusChanged = new EventEmitter();
        this.onVideoStatusChanged = new EventEmitter();
        this.displayUserPanel = new EventEmitter();
        this.onLeaveCall = new EventEmitter();
        this.isSettingsOn = false;
        this.reasonOfFlagging = '';
        this.flagged = false;
        this.hover = false;
        this.below = 'below';
        this.virtualBackgroundEnabled = this.zoomService.isVirtualBackgroundEnabled();
    }
    ngOnInit() {
        super.ngOnInit();
        this.getAvailableSpeakersSubscription = this.zoomService.getAvailableSpeakers().subscribe(speakers => {
            this.speakerList = speakers;
        });
        this.getAvailableCamerasSubscription = this.zoomService.getAvailableCameras().subscribe(cameras => {
            this.cameraList = cameras;
        });
        this.getAvailableMicrophonesSubscription = this.zoomService.getAvailableMicrophones().subscribe(microphones => {
            this.microphoneList = microphones;
        });
        this.selectedCameraSubscription = this.zoomService.selectedCamera$().subscribe(value => {
            this.selectedCamera = value;
        });
        this.selectedSpeakerSubscription = this.zoomService.selectedSpeaker$().subscribe(value => {
            this.selectedSpeaker = value;
        });
        this.selectedMicSubscription = this.zoomService.selectedMic$().subscribe(value => {
            this.selectedMicrophone = value;
        });
        this.selectedVirtualBackgroundSubscription = this.zoomService.virtualBackground$().subscribe(value => {
            this.selectedVirtualBackground = value;
        });
        console.log(this.session);
        if (this.session != null) {
            this.sessionStartTimeFormatted = moment(this.session.sessionStartTime).format("hh:mm a");
            this.coachee = this.session.user;
        }
        else {
            console.log("Session can not be retrieved.");
        }
    }
    selectSpeaker(speaker) {
        this.zoomService.switchSpeaker(speaker);
    }
    selectCamera(camera) {
        this.zoomService.switchCamera(camera);
    }
    selectMicrophone(microphone) {
        this.zoomService.switchMic(microphone);
    }
    toggleUserPanel() {
        this.displayUserPanel.emit();
    }
    leaveCall() {
        this.onLeaveCall.emit();
    }
    openReportCoachModal() {
        this.reportSuccessMessage = 'sessionChat.messages.coachIsFlagged';
        this.modalService.open(this.reportClientModal);
    }
    reportClient() {
        this.showReasonOfFlaggingRequired = false;
        this.flagged = false;
        if (this.reasonOfFlagging === '') {
            this.showReasonOfFlaggingRequired = true;
            return;
        }
        this.userService.reportClient({ id: this.session.user.id, reasonOfFlagging: this.reasonOfFlagging }, this.session.id).subscribe(() => {
            this.flagged = true;
        }, error => console.error('client cannot be flagged: ' + error));
    }
    selectVirtualBackground(virtualBackgroundType) {
        this.zoomService.changeVirtualBackground(virtualBackgroundType);
    }
    onDismiss($event) {
        console.log($event);
        this.flagged = false;
    }
    ngOnDestroy() {
        var _a, _b, _c, _d, _e, _f, _g;
        super.ngOnDestroy();
        (_a = this.getAvailableSpeakersSubscription) === null || _a === void 0 ? void 0 : _a.unsubscribe();
        (_b = this.getAvailableMicrophonesSubscription) === null || _b === void 0 ? void 0 : _b.unsubscribe();
        (_c = this.getAvailableSpeakersSubscription) === null || _c === void 0 ? void 0 : _c.unsubscribe();
        (_d = this.selectedMicSubscription) === null || _d === void 0 ? void 0 : _d.unsubscribe();
        (_e = this.selectedCameraSubscription) === null || _e === void 0 ? void 0 : _e.unsubscribe();
        (_f = this.selectedSpeakerSubscription) === null || _f === void 0 ? void 0 : _f.unsubscribe();
        (_g = this.selectedVirtualBackgroundSubscription) === null || _g === void 0 ? void 0 : _g.unsubscribe();
    }
}
UserSessionControlComponent.ɵfac = function UserSessionControlComponent_Factory(t) { return new (t || UserSessionControlComponent)(i0.ɵɵdirectiveInject(i1.MessageService), i0.ɵɵdirectiveInject(i2.JhiAlertService), i0.ɵɵdirectiveInject(i3.SessionStorageService), i0.ɵɵdirectiveInject(i4.SessionService), i0.ɵɵdirectiveInject(i5.NgbModal), i0.ɵɵdirectiveInject(i6.TranslateService), i0.ɵɵdirectiveInject(i7.AccountService), i0.ɵɵdirectiveInject(i8.CoachDetailsService), i0.ɵɵdirectiveInject(i9.UserOrganizationCodeService), i0.ɵɵdirectiveInject(i10.DataSharingConsentService), i0.ɵɵdirectiveInject(i2.JhiEventManager), i0.ɵɵdirectiveInject(i11.ZoomService), i0.ɵɵdirectiveInject(i12.UserInteractionService), i0.ɵɵdirectiveInject(i5.NgbModal), i0.ɵɵdirectiveInject(i13.UserService), i0.ɵɵdirectiveInject(i14.TrackerService)); };
UserSessionControlComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: UserSessionControlComponent, selectors: [["user-session-control"]], viewQuery: function UserSessionControlComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.reportClientModal = _t.first);
    } }, inputs: { session: "session", isAudioOn: "isAudioOn", isVideoOn: "isVideoOn", showUnreadIndicator: "showUnreadIndicator", isUserPanelOn: "isUserPanelOn" }, outputs: { onAudioStatusChanged: "onAudioStatusChanged", onVideoStatusChanged: "onVideoStatusChanged", displayUserPanel: "displayUserPanel", onLeaveCall: "onLeaveCall" }, features: [i0.ɵɵInheritDefinitionFeature], decls: 77, vars: 37, consts: [[1, "olha-theme"], [1, "navbar"], [1, "d-flex", "align-items-center"], [1, "mr-2", "text-center"], ["jhiTranslate", "sessionChat.header.timeInfo", 1, "mr-1", "minutes", 3, "translateValues"], ["ngbDropdown", "", 1, "d-inline-block", "text-dark", "align-middle"], ["ngbDropdownToggle", "", "href", "javascript:void(0);", 1, "language-anchor"], [1, "box-button", "d-flex", "align-items-center", "justify-content-center", "m-1", 3, "ngStyle", "matTooltipPosition", "matTooltipClass", "matTooltip", "mouseover", "mouseleave", "click"], [1, "m-1"], ["width", "22", "height", "22"], ["id", "actual-icon", 0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#settings"], ["ngbDropdownMenu", "", 1, "dropdown-menu", "dropdown-menu-settings", "dropdown-menu-right", "dropdown-menu-location-primary"], ["primaryDropdown", ""], [4, "ngIf"], [1, "d-flex", "justify-content-between", "align-items-center"], ["ngbDropdown", "", 1, "d-inline-block", "text-dark", "align-middle", "w-100"], ["cameraDropdown", "ngbDropdown"], [1, "align-items-center", "justify-content-center", "m-1"], ["jhiTranslate", "sessionChat.coachSessionControl.selectCamera", 1, "item-bold"], [1, "d-flex", "justify-content-start", "align-items-center"], ["width", "14", "height", "14"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#tick-mark"], [1, "item-light"], ["icon", "chevron-right", 1, "ml-2"], ["ngbDropdownMenu", "", 1, "dropdown-menu", "dropdown-menu-camera", "dropdown-menu-right"], ["class", "item-light mb-2", 3, "click", 4, "ngFor", "ngForOf"], ["microphoneDropdown", "ngbDropdown"], ["jhiTranslate", "sessionChat.coachSessionControl.selectMicrophone", 1, "item-bold"], [1, "box-button", "box-button-toggle", "d-flex", "align-items-center", "justify-content-center", "m-1", 3, "ngClass", "ngStyle", "matTooltipPosition", "matTooltipClass", "matTooltip", "click", "mouseover", "mouseleave"], [1, "position-relative", "m-1"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#panel-light", 4, "ngIf"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#panel", 4, "ngIf"], ["class", "unread-indicator", 4, "ngIf"], [1, "box-button", "box-button-dropdown", "d-flex", "align-items-center", "justify-content-center", "m-1"], ["icon", "ellipsis-h", 2, "font-size", "18px"], ["ngbDropdownMenu", "", 1, "dropdown-menu", "dropdown-menu-3dots", "dropdown-menu-right", "dropdown-menu-location-primary"], [1, "dropdown-item", "p-0"], ["target", "_blank", "jhiTranslate", "sessionChat.button.resources", "routerLink", "/resources-for-help", 1, "item-bold", "light-green", "dropdown-item", "p-0"], ["class", "dropdown-item p-0", 3, "click", 4, "ngIf"], [1, "vertical-line"], [3, "tooltipPosition"], [1, "mr-2"], [1, "btn", "btn-primary", "stop-button", 3, "click"], ["jhiTranslate", "sessionChat.userSessionControl.leaveCall"], ["reportClientModal", ""], ["speakerDropdown", "ngbDropdown"], ["jhiTranslate", "sessionChat.coachSessionControl.selectSpeaker", 1, "item-bold"], ["ngbDropdownMenu", "", 1, "dropdown-menu", "dropdown-menu-speakers", "dropdown-menu-right"], [1, "item-light", "mb-2", 3, "click"], ["virtualBackgroundDropdown", "ngbDropdown"], ["jhiTranslate", "sessionChat.paragraph.virtualBackgrounds", 1, "item-bold"], [1, "item-light", 3, "jhiTranslate"], [3, "virtualBackgroundSelected"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#panel-light"], [0, "xlink", "href", "../../../../content/images/sprite.svg?v=3#panel"], [1, "unread-indicator"], [1, "dropdown-item", "p-0", 3, "click"], ["jhiTranslate", "sessionChat.button.reportCoach", 1, "item-bold", "light-green", "dropdown-item", "p-0"], ["class", "modal-body", 4, "ngIf"], [3, "titleText", "message", "dismissed", 4, "ngIf"], [1, "modal-body"], [1, "text-center", "my-4"], ["jhiTranslate", "sessionChat.header.reason"], ["inputAutoDirectionSwitch", "", "id", "session-chat-report-reason-input", "rows", "5", 1, "form-control", 3, "placeholder", "ngModel", "ngModelChange"], ["jhiTranslate", "sessionChat.paragraph.reason", 4, "ngIf"], [1, "text-center"], ["id", "session-chat-report-submit", "type", "button", "jhiTranslate", "sessionChat.button.submit", 1, "btn-2", "btn-2-black", 3, "click"], ["jhiTranslate", "sessionChat.paragraph.reason"], [3, "titleText", "message", "dismissed"]], template: function UserSessionControlComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "nav", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelement(4, "span", 4);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "div", 2);
        i0.ɵɵelementStart(6, "div");
        i0.ɵɵelementStart(7, "span", 5);
        i0.ɵɵelementStart(8, "a", 6);
        i0.ɵɵelementStart(9, "div", 7);
        i0.ɵɵlistener("mouseover", function UserSessionControlComponent_Template_div_mouseover_9_listener() { return ctx.hover = true; })("mouseleave", function UserSessionControlComponent_Template_div_mouseleave_9_listener() { return ctx.hover = false; })("click", function UserSessionControlComponent_Template_div_click_9_listener() { return ctx.isSettingsOn = !ctx.isSettingsOn; });
        i0.ɵɵpipe(10, "translate");
        i0.ɵɵelementStart(11, "div", 8);
        i0.ɵɵelementStart(12, "div");
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(13, "svg", 9);
        i0.ɵɵelement(14, "use", 10);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(15, "ul", 11, 12);
        i0.ɵɵtemplate(17, UserSessionControlComponent_li_17_Template, 16, 4, "li", 13);
        i0.ɵɵelementStart(18, "li");
        i0.ɵɵelementStart(19, "div", 14);
        i0.ɵɵelementStart(20, "span", 15, 16);
        i0.ɵɵelementStart(22, "a", 6);
        i0.ɵɵelementStart(23, "div", 17);
        i0.ɵɵelement(24, "span", 18);
        i0.ɵɵelementStart(25, "div", 14);
        i0.ɵɵelementStart(26, "div", 19);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(27, "svg", 20);
        i0.ɵɵelement(28, "use", 21);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(29, "span", 22);
        i0.ɵɵtext(30);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(31, "fa-icon", 23);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(32, "ul", 24);
        i0.ɵɵtemplate(33, UserSessionControlComponent_li_33_Template, 2, 1, "li", 25);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(34, "li");
        i0.ɵɵelementStart(35, "div");
        i0.ɵɵelementStart(36, "span", 15, 26);
        i0.ɵɵelementStart(38, "a", 6);
        i0.ɵɵelementStart(39, "div", 17);
        i0.ɵɵelement(40, "span", 27);
        i0.ɵɵelementStart(41, "div", 14);
        i0.ɵɵelementStart(42, "div", 19);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(43, "svg", 20);
        i0.ɵɵelement(44, "use", 21);
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(45, "span", 22);
        i0.ɵɵtext(46);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(47, "fa-icon", 23);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(48, "ul", 24);
        i0.ɵɵtemplate(49, UserSessionControlComponent_li_49_Template, 2, 1, "li", 25);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(50, UserSessionControlComponent_li_50_Template, 16, 3, "li", 13);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(51, "div", 28);
        i0.ɵɵlistener("click", function UserSessionControlComponent_Template_div_click_51_listener() { return ctx.toggleUserPanel(); })("mouseover", function UserSessionControlComponent_Template_div_mouseover_51_listener() { return ctx.hover = true; })("mouseleave", function UserSessionControlComponent_Template_div_mouseleave_51_listener() { return ctx.hover = false; });
        i0.ɵɵpipe(52, "translate");
        i0.ɵɵelementStart(53, "div", 29);
        i0.ɵɵnamespaceSVG();
        i0.ɵɵelementStart(54, "svg", 9);
        i0.ɵɵtemplate(55, UserSessionControlComponent__svg_use_55_Template, 1, 0, "use", 30);
        i0.ɵɵtemplate(56, UserSessionControlComponent__svg_use_56_Template, 1, 0, "use", 31);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(57, UserSessionControlComponent_div_57_Template, 1, 0, "div", 32);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵnamespaceHTML();
        i0.ɵɵelementStart(58, "div", 33);
        i0.ɵɵelementStart(59, "span", 5);
        i0.ɵɵelementStart(60, "a", 6);
        i0.ɵɵelementStart(61, "div", 33);
        i0.ɵɵelement(62, "fa-icon", 34);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(63, "ul", 35);
        i0.ɵɵelementStart(64, "li", 36);
        i0.ɵɵelement(65, "a", 37);
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(66, UserSessionControlComponent_li_66_Template, 2, 0, "li", 38);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelement(67, "div", 39);
        i0.ɵɵelementStart(68, "div");
        i0.ɵɵelement(69, "audio-toggler", 40);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(70, "div");
        i0.ɵɵelement(71, "video-toggler", 40);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(72, "div", 41);
        i0.ɵɵelementStart(73, "button", 42);
        i0.ɵɵlistener("click", function UserSessionControlComponent_Template_button_click_73_listener() { return ctx.leaveCall(); });
        i0.ɵɵelement(74, "span", 43);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵtemplate(75, UserSessionControlComponent_ng_template_75_Template, 2, 2, "ng-template", null, 44, i0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r0 = i0.ɵɵreference(16);
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("translateValues", i0.ɵɵpureFunction2(30, _c1, ctx.session.duration, ctx.sessionStartTimeFormatted));
        i0.ɵɵadvance(5);
        i0.ɵɵproperty("ngStyle", ctx.hover ? i0.ɵɵpureFunction0(33, _c2) : i0.ɵɵpureFunction0(34, _c3))("matTooltipPosition", "below")("matTooltipClass", "feedback-tool-tip")("matTooltip", i0.ɵɵpipeBind1(10, 26, ctx.isSettingsOn ? "sessionChat.coachSessionControl.hideSettings" : "sessionChat.coachSessionControl.showSettings"));
        i0.ɵɵadvance(8);
        i0.ɵɵproperty("ngIf", ctx.speakerList == null ? null : ctx.speakerList.length);
        i0.ɵɵadvance(13);
        i0.ɵɵtextInterpolate(ctx.selectedCamera.label);
        i0.ɵɵadvance(2);
        i0.ɵɵstyleProp("left", _r0.offsetWidth - 20 + "px");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.cameraList);
        i0.ɵɵadvance(13);
        i0.ɵɵtextInterpolate(ctx.selectedMicrophone == null ? null : ctx.selectedMicrophone.label);
        i0.ɵɵadvance(2);
        i0.ɵɵstyleProp("left", _r0.offsetWidth - 20 + "px");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.microphoneList);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.virtualBackgroundEnabled);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngClass", ctx.isUserPanelOn ? "box-button-toggle-active" : "")("ngStyle", ctx.hover ? i0.ɵɵpureFunction0(35, _c2) : i0.ɵɵpureFunction0(36, _c3))("matTooltipPosition", "below")("matTooltipClass", "feedback-tool-tip")("matTooltip", i0.ɵɵpipeBind1(52, 28, ctx.isUserPanelOn ? "sessionChat.userSessionControl.hideChatsAndActionPlan" : "sessionChat.userSessionControl.showChatsAndActionPlan"));
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.isUserPanelOn);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", !ctx.isUserPanelOn);
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.showUnreadIndicator);
        i0.ɵɵadvance(9);
        i0.ɵɵproperty("ngIf", ctx.session != null);
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("tooltipPosition", ctx.below);
        i0.ɵɵadvance(2);
        i0.ɵɵproperty("tooltipPosition", ctx.below);
    } }, directives: [i5.NgbNavbar, i15.JhiTranslateDirective, i5.NgbDropdown, i5.NgbDropdownToggle, i16.NgStyle, i17.MatTooltip, i5.NgbDropdownMenu, i16.NgIf, i18.FaIconComponent, i16.NgForOf, i16.NgClass, i19.RouterLinkWithHref, i20.AudioTogglerComponent, i21.VideoTogglerComponent, i22.VirtualBackgroundSelectorComponent, i23.DefaultValueAccessor, i24.InputAutoDirectionSwitchDirective, i23.NgControlStatus, i23.NgModel, i25.ModalSuccessComponent], pipes: [i6.TranslatePipe], styles: [".navbar[_ngcontent-%COMP%]{background:#f7eed2;padding-left:20px !important;padding-right:20px !important}.time-left[_ngcontent-%COMP%]{font-family:Poppins,sans-serif}.minutes[_ngcontent-%COMP%]{font-family:Poppins,sans-serif;font-weight:600;color:#44a38b}.box-button[_ngcontent-%COMP%]{font-family:Poppins,sans-serif;font-weight:400;width:80px;height:50px;color:#44a38b;background:#f7eed2;border-radius:8px;flex-direction:column;cursor:pointer}.box-button-wide[_ngcontent-%COMP%]{width:145px !important}.box-button-toggle[_ngcontent-%COMP%]:active, .box-button-dropdown[_ngcontent-%COMP%]:hover, .box-button-toggle-active[_ngcontent-%COMP%]{color:#f7eed2;background:#44a38b}h3[_ngcontent-%COMP%]{margin-bottom:0}h5[_ngcontent-%COMP%]{margin-bottom:0}.dropdown-menu[_ngcontent-%COMP%]{padding:15px 25px;box-shadow:0 10px 20px rgba(0,0,0,.13);border-radius:10px;border:none}.dropdown-menu-settings[_ngcontent-%COMP%], .dropdown-menu-speakers[_ngcontent-%COMP%], .dropdown-menu-camera[_ngcontent-%COMP%], .dropdown-menu-3dots[_ngcontent-%COMP%]{min-width:-moz-fit-content;min-width:fit-content}.dropdown-menu-location-primary[_ngcontent-%COMP%]{top:65px !important;right:5px !important}.dropdown-toggle[_ngcontent-%COMP%]:after{display:none !important}.dropdown-item-disabled[_ngcontent-%COMP%]{background-color:#fff;color:#7cbfae !important;font-weight:bold}.dropdown-item[_ngcontent-%COMP%]:hover, .dropdown-item-disabled[_ngcontent-%COMP%]:hover{background-color:#fff;color:#0a4a3a;text-decoration:underline}a[_ngcontent-%COMP%]{text-decoration:none}.item-bold[_ngcontent-%COMP%]{margin-bottom:15px;font-family:\"Poppins\",serif;font-style:normal;font-weight:700;font-size:14px;line-height:25px;color:#0a4a3a;cursor:pointer}.item-light[_ngcontent-%COMP%]{margin-left:10px;font-family:\"Poppins\",serif;font-style:normal;font-weight:400;font-size:14px;line-height:20px;color:#44a38b;cursor:pointer;white-space:nowrap}.light-green[_ngcontent-%COMP%]{color:#44a38b !important}.stop-button[_ngcontent-%COMP%]{background:var(--accent-2) !important}.vertical-line[_ngcontent-%COMP%]{width:44px;height:2px;border:1px solid #44a38b;transform:rotate(90deg)}.unread-indicator[_ngcontent-%COMP%]{background-color:var(--accent-2) !important;position:absolute;border-radius:50%;height:8px;width:8px;top:-2px;right:-3px}[_nghost-%COMP%]  .feedback-tool-tip{color:#fff !important;background:#44a38b !important;font-size:14px !important}[_nghost-%COMP%]  .feedback-tool-tip:before{content:\"\";position:absolute;left:calc(50% - 10px) !important;z-index:10000}"] });
